import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const empty = { name:'', email:'', phone:'', address:'', gst_number:'' };

export default function Clients() {
  const [rows, setRows]       = useState([]);
  const [loading, setLoad]    = useState(true);
  const [search, setSearch]   = useState('');
  const [modal, setModal]     = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm]       = useState(empty);
  const [saving, setSaving]   = useState(false);

  const fetch = useCallback(() => {
    setLoad(true);
    api.get('/clients', { params:{ search } })
      .then(r=>{ setRows(r.data.data||[]); setLoad(false); }).catch(()=>setLoad(false));
  }, [search]);

  useEffect(()=>{ const t=setTimeout(fetch,300); return ()=>clearTimeout(t); }, [fetch]);

  const openNew  = () => { setEditing(null); setForm(empty); setModal(true); };
  const openEdit = (c) => { setEditing(c); setForm({ name:c.name, email:c.email||'', phone:c.phone||'', address:c.address||'', gst_number:c.gst_number||'' }); setModal(true); };

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await api.put(`/clients/${editing.id}`, form); toast.success('Client updated'); }
      else         { await api.post('/clients', form);               toast.success('Client added'); }
      setModal(false); fetch();
    } finally { setSaving(false); }
  };

  const del = async (id, name) => {
    if (!window.confirm(`Delete ${name}? This cannot be undone.`)) return;
    await api.delete(`/clients/${id}`); toast.success('Deleted'); fetch();
  };

  return (
    <div>
      <div className="page-header">
        <div><h2 className="page-title">Clients</h2><p className="page-subtitle">{rows.length} client{rows.length!==1?'s':''}</p></div>
        <div className="page-actions">
          <div className="search-box"><span>🔍</span><input placeholder="Search clients…" value={search} onChange={e=>setSearch(e.target.value)} /></div>
          <button className="btn btn-primary" onClick={openNew}>+ Add Client</button>
        </div>
      </div>

      <div className="card" style={{ padding:0 }}>
        {loading ? <div style={{ padding:40,textAlign:'center',color:'var(--text3)' }}>Loading…</div>
        : rows.length===0 ? (
          <div className="empty-state"><div className="empty-icon">👥</div><h3>No clients yet</h3>
            <p>Add your first client to get started</p>
            <button className="btn btn-primary" onClick={openNew}>+ Add Client</button></div>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Client</th><th>Email</th><th>Phone</th><th>GST</th><th>Invoices</th><th>Quotations</th><th>Actions</th></tr></thead>
              <tbody>
                {rows.map(c=>(
                  <tr key={c.id}>
                    <td>
                      <div style={{ display:'flex',alignItems:'center',gap:9 }}>
                        <div style={{ width:30,height:30,background:'var(--accentGlow)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'var(--accent)',flexShrink:0 }}>
                          {c.name[0].toUpperCase()}
                        </div>
                        <span style={{ fontWeight:600 }}>{c.name}</span>
                      </div>
                    </td>
                    <td>{c.email||'—'}</td>
                    <td>{c.phone||'—'}</td>
                    <td style={{ fontSize:12 }}>{c.gst_number||'—'}</td>
                    <td><span style={{ background:'var(--infoBg)',color:'var(--info)',padding:'2px 8px',borderRadius:100,fontSize:12 }}>{c.invoice_count}</span></td>
                    <td><span style={{ background:'var(--accentGlow)',color:'var(--accent2)',padding:'2px 8px',borderRadius:100,fontSize:12 }}>{c.quotation_count}</span></td>
                    <td>
                      <div style={{ display:'flex',gap:4 }}>
                        <button className="btn btn-sm btn-secondary btn-icon" onClick={()=>openEdit(c)} title="Edit">✏️</button>
                        <button className="btn btn-sm btn-danger btn-icon" onClick={()=>del(c.id,c.name)} title="Delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <h3 style={{ fontFamily:'Syne,sans-serif',fontWeight:700 }}>{editing?'Edit Client':'New Client'}</h3>
              <button className="btn btn-sm btn-secondary btn-icon" onClick={()=>setModal(false)}>✕</button>
            </div>
            <form onSubmit={save}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Name *</label>
                  <input className="form-control" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Client / Company name" required /></div>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Email</label>
                    <input type="email" className="form-control" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="email@example.com" /></div>
                  <div className="form-group"><label className="form-label">Phone</label>
                    <input className="form-control" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="+91 98765 43210" /></div>
                </div>
                <div className="form-group"><label className="form-label">Address</label>
                  <textarea className="form-control" value={form.address} onChange={e=>setForm({...form,address:e.target.value})} placeholder="Full address…" rows={3} /></div>
                <div className="form-group"><label className="form-label">GST Number</label>
                  <input className="form-control" value={form.gst_number} onChange={e=>setForm({...form,gst_number:e.target.value})} placeholder="e.g. 33ABCDE1234F1Z5" /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving?<span className="spinner"/>:(editing?'Update':'Add Client')}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
